import { getJson, pathSegment } from "../client";
import { RESUME_BASE } from "./base";

/** What a tailor changed against the version it was tailored from. */

export type ResumeChangeKind = "REWORDED" | "REORDERED" | "DROPPED" | "ADDED" | "UNCHANGED";

export type ResumeSection =
    "HEADLINE" | "SUMMARY" | "SKILLS" | "EXPERIENCE" | "EDUCATION" | "CERTIFICATIONS";

/** A role, by what the tailor may not change about it. */
export interface ChangedRole {
    company: string;
    title: string;
}

/**
 * One thing a tailor did, or left as it was. A rewording has one text
 * each side; a reordering, the items in the baseline's order and in the
 * tailored order; a drop, what was left out, in `before`; an addition,
 * what was added, in `after`. Both empty when nothing changed.
 */
export interface ResumeChange {
    kind: ResumeChangeKind;
    section: ResumeSection;
    /** The role it is in, for a change to the experience. */
    role?: ChangedRole | null;
    before: string[];
    after: string[];
}

/** What a tailor changed against the version it was tailored from. `resume_api::responses::TailoredResumeChanges`. */
export interface TailoredResumeChanges {
    resume_id: string;
    /** The version of the person's resume it was tailored from. */
    baseline_version: number;
    /** In the resume's order: the headline, the summary, the skills, each role, the education, the certifications. */
    changes: ResumeChange[];
}

/** What one tailored resume changed. 404 for one kept before its text was. */
export async function getTailoredChanges(resumeId: string): Promise<TailoredResumeChanges> {
    return getJson(`${RESUME_BASE}/tailored/${pathSegment(resumeId)}/changes`);
}
